import React, { useRef, useState, useEffect } from 'react';
import Slider from 'react-slick';
import {
    TableRow,
    TableBody,
    TableCell
} from '@mui/material';
import { IconArrowSwipeLeft, IconArrowSwipeRight } from '../../../../assets/images/icons'

import {
    BarWrapper,
    StyledTableHead,
    TableData,
    TableWrapper,
    TdWrapper,
    BoxRow,
    BoxCell,
    ButtonWrapper,
    TableWithSliderWrapper,
    TableWithSliderOuterWrapper
} from './style'

const TableWithSlider = ({
    view,
    data,
    tableData,
    colors,
    maxValue,
    sortedPieColorObject
}) => {
    const headerSliderRef = useRef(null);
    const bodySliderRefs = useRef([]);
    const sliderContainerRef = useRef(null);
    const [sliderWidth, setSliderWidth] = useState(null);
    const [showSlider, setShowSlider] = useState(false);
    const [isHovering, setIsHovering] = useState(false);

    useEffect(() => {
        if (sliderContainerRef.current) {
            // Wait for DOM to fully render, then get the computed width
            const timer = setTimeout(() => {
                if (sliderContainerRef.current && !sliderWidth) {
                    const computedWidth = sliderContainerRef.current.offsetWidth - 20;
                    if (tableData[0].length > 5) {
                        sliderContainerRef.current.style.width = computedWidth + 'px';
                        setSliderWidth(computedWidth - 200)
                        setShowSlider(true)
                    };
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [sliderWidth]);

    useEffect(() => {
        setShowSlider(tableData[0].length > 5)
    }, []);

    const handleNext = () => {
        if (headerSliderRef.current?.innerSlider) {
            const slider = headerSliderRef.current.innerSlider;
            if (slider.state.currentSlide < slider.state.slideCount - slider.props.slidesToShow) {
                headerSliderRef.current.slickNext();
            }
        }

        bodySliderRefs.current.forEach((sliderRef, idx) => {
            if (sliderRef?.innerSlider) {
                const slider = sliderRef.innerSlider;
                if (slider.state.currentSlide < slider.state.slideCount - slider.props.slidesToShow) {
                    sliderRef.slickNext();
                }
            }
        });
    };

    const handlePrev = () => {
        if (headerSliderRef.current?.innerSlider) {
            if (headerSliderRef.current.innerSlider.state.currentSlide > 0) {
                headerSliderRef.current.slickPrev();
            }
        }

        bodySliderRefs.current.forEach((sliderRef, idx) => {
            if (sliderRef?.innerSlider?.state.currentSlide > 0) {
                sliderRef.slickPrev();
            }
        });
    };

    const sliderSettings = {
        dots: false,
        infinite: false,
        slidesToShow: 6.2,
        slidesToScroll: 1,
        swipeToSlide: false,
        draggable: false,
        touchMove: false,
        speed: 0,
        arrows: false
    };

    if (view !== 'table') return null;

    if (!data?.length || tableData.length <= 1) {
        return (
            <TableWrapper>
                <TableRow>
                    <TableCell>
                        <b>No Data</b>
                    </TableCell>
                </TableRow>
            </TableWrapper>
        );
    }

    const settings = {
        className: "slider variable-width",
        centerMode: false,
        dots: false,
        infinite: false,
        slidesToShow: 4.5,
        arrows: false
    };

    return (
        <TableWithSliderOuterWrapper
            style={{ position: 'relative' }}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            {!!data?.length && tableData.length > 1 ? (
                <TableWithSliderWrapper>

                    <div className="slider-container carousel-with-sticky-first header" ref={sliderContainerRef} style={{ width: sliderWidth ? sliderWidth + 'px' : (showSlider ? '100%' : 'calc(100% - 200px)') }}>
                        <div className="first-fixed dotted">{tableData[0][0].value}</div>
                        {sliderWidth && tableData[0].length > 5 ? (
                            <Slider ref={headerSliderRef} {...settings}>
                                {tableData[0].map((td, ind) => {
                                    if (ind === 0) return;
                                    if (!td.show) return;
                                    return (
                                        <BoxCell style={{ height: '40px' }} className='sliderHeading dotted' key={'th' + ind}>{td.value}</BoxCell>
                                    )
                                })}
                            </Slider>
                        ) : (
                            <div className="plain-header" style={{ display: 'flex' }}>
                                {tableData[0].map((td, ind) => {
                                    if (ind === 0) return;
                                    if (!td.show) return null;
                                    return (
                                        <BoxCell style={{ width: `calc(100% / ${tableData[0].length - 1})`, height: '40px', display: 'flex', alignItems: 'center', paddingLeft: '10px' }} className='sliderHeading dotted' key={'th' + ind}>{td.value}</BoxCell>
                                    )
                                })}
                            </div>
                        )}
                    </div>


                    {tableData.slice(1).map((row, rowIndex) => {
                        return (
                            <div key={'row' + rowIndex} className="slider-container carousel-with-sticky-first body" style={{ width: sliderWidth ? sliderWidth + 'px' : (showSlider ? '100%' : 'calc(100% - 200px)') }}>
                                <div className="first-fixed dotted">{row[0].value}</div>
                                {sliderWidth && row.length > 5 ? (
                                    <Slider ref={el => { bodySliderRefs.current[rowIndex] = el; }} {...settings}>
                                        {row.map((cell, cellIndex) => {
                                            let w = 100 / row.length
                                            if (w < 12) w = 12;
                                            if (cellIndex === 0) w = '200px';
                                            if (w === 12 && row.length > 8) w = '150px';
                                            else w = w + '%';

                                            if (cellIndex === 0) return;
                                            if (!cell.show) return;
                                            // const clr = sortedPieColorObject[cell.key]
                                            const clr = sortedPieColorObject?.[cell?.key] || sortedPieColorObject[cellIndex]
                                            return (
                                                <TableData key={'row' + rowIndex + '_cell' + cellIndex} style={{ width: w, height: '40px' }}>
                                                    <TdWrapper index={cellIndex} textColor={cellIndex !== 0 ? clr : ''}>
                                                        {cellIndex !== 0 ?
                                                            <BarWrapper bgColor={clr} width='calc(100% - 40px)' barWidth={(cell.value / maxValue) * 100}>
                                                                <div className='bar-filled'></div>
                                                            </BarWrapper>
                                                            : ''}
                                                        {cell.value}{cellIndex !== 0 ? '%' : ''}
                                                    </TdWrapper>
                                                </TableData>
                                            )
                                        })}
                                    </Slider>
                                ) : (
                                    <div className="plain-row" style={{ display: 'flex' }}>
                                        {row.map((cell, cellIndex) => {
                                            if (cellIndex === 0) return null;
                                            if (!cell.show) return null;
                                            const clr = sortedPieColorObject?.[cell?.key] || sortedPieColorObject[cellIndex]

                                            return (
                                                <TableData key={'row' + rowIndex + '_cell' + cellIndex} style={{ width: `calc(100% / ${row.length - 1})`, height: '40px' }}>
                                                    <TdWrapper index={cellIndex} textColor={cellIndex !== 0 ? clr : ''}>
                                                        {cellIndex !== 0 ?
                                                            <BarWrapper bgColor={clr} width='calc(100% - 40px)' barWidth={(cell.value / maxValue) * 100}>
                                                                <div className='bar-filled'></div>
                                                            </BarWrapper>
                                                            : ''}
                                                        {cell.value}{cellIndex !== 0 ? '%' : ''}
                                                    </TdWrapper>
                                                </TableData>
                                            )
                                        })}
                                    </div>
                                )}
                            </div>
                        )
                    })}

                </TableWithSliderWrapper>

            ) : (
                <TableRow>
                    <TableCell>
                        <b>No Data</b>
                    </TableCell>
                </TableRow>
            )}

            {sliderWidth &&
                <ButtonWrapper
                    style={{ opacity: isHovering ? 1 : 0, visibility: isHovering ? 'visible' : 'hidden', transition: 'opacity 0.3s, visibility 0.3s' }}
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                >
                    <button onClick={handlePrev}><IconArrowSwipeLeft /></button>
                    <button onClick={handleNext}><IconArrowSwipeRight /></button>
                </ButtonWrapper>}
        </TableWithSliderOuterWrapper>
    );
};

export default TableWithSlider;
